import { MatIconModule } from '@angular/material/icon';
import { CommonModule, DOCUMENT } from '@angular/common';
import { MatChipsModule } from '@angular/material/chips';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderComponent } from 'app/components/header/header.component';
import { FooterComponent } from 'app/components/footer/footer.component';
import { Component, Inject, OnInit, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { CgcNearestLocationMobileComponent } from '../cgc-nearest-location-mobile/cgc-nearest-location-mobile.component';
import {} from 'googlemaps';

import { branch } from 'assets/js/branches_list.js';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-cgc-nearest-location',
  templateUrl: './cgc-nearest-location.component.html',
  styleUrls: ['./cgc-nearest-location.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    MatIconModule,
    MatChipsModule,
    HeaderComponent,
    FooterComponent,
    MatButtonModule,
    MatDialogModule,
    TranslateModule,
  ],
  standalone: true
})
export class CgcNearestLocationComponent implements OnInit {

  branchLists: any;
  allBranchList: any;
  languageSelected: any;
  clickedOutside: boolean = false;
  selectedLanguage: any;

  @ViewChild('map') mapElement: any;
  map: google.maps.Map;

  mapOption: any = {
    zoom: 7,
    center: { lat: 3.0951467, lng: 101.5920125 },
    styles: [
      {
          'featureType': 'administrative',
          'elementType': 'all',
          'stylers': [{
              'visibility': 'on',
          },
          {
              'lightness': 33,
          },],
      },
      {
          'featureType': 'landscape',
          'elementType': 'all',
          'stylers': [{
              'color': '#f2e5d4',
          }],
      },
      {
          'featureType': 'poi.park',
          'elementType': 'geometry',
          'stylers': [{
              'color': '#c5dac6',
          }],
      },
      {
          'featureType': 'poi.park',
          'elementType': 'labels',
          'stylers': [{
              'visibility': 'on',
          },
          {
              'lightness': 20,
          }],
      },
      {
          'featureType': 'road',
          'elementType': 'all',
          'stylers': [{
              'lightness': 20,
          }],
      },
      {
          'featureType': 'road.highway',
          'elementType': 'geometry',
          'stylers': [{
              'color': '#c5c6c6',
          }],
      },
      {
          'featureType': 'road.arterial',
          'elementType': 'geometry',
          'stylers': [{
              'color': '#e4d7c6',
          }],
      },
      {
          'featureType': 'road.local',
          'elementType': 'geometry',
          'stylers': [{
              'color': '#fbfaf7',
          }],
      },
      {
          'featureType': 'water',
          'elementType': 'all',
          'stylers': [{
              'visibility': 'on',
          },
          {
              'color': '#acbcc9',
          }],
      },
    ]
  }

  mobileMapData: any = {};

  constructor(
    @Inject(DOCUMENT) private document: Document,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private renderer2: Renderer2,
    private toastr: ToastrService
  ) {
    this.route.queryParams.subscribe(params => {
      this.languageSelected = params.lang;
    })
  }

  ngOnInit() {
    this.selectedLanguage = localStorage.getItem('language');
    const url = `https://maps.googleapis.com/maps/api/js?key=${environment.GOOGLE_MAPS_API_KEY}&libraries=places&callback=Function.prototype&solution_channel=GMP_codelabs_simplestorelocator_v1_a`;
    this.loadScript(url).then(() => {
      this.loadMap('first_entry', null);
      this.getBranchListing();
      (<HTMLInputElement>document.getElementById('search')).value = null;
    });
  }

  loadScript(url) {
    return new Promise((resolve, reject) => {
      const script = this.renderer2.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      script.text = ``;
      script.onload = resolve;
      script.onerror = reject;
      this.renderer2.appendChild(this.document.head, script);
    });
  }

  switchedLanguage(data: any) {
    this.selectedLanguage = data;
  }

  groupingFunction(data) {
    let groups = Object.keys(data).map(function (key) {
      return { state: key, data: data[key] };
    });
    
    return groups;
  }

  getBranchListing() {
    let list = branch.features;

    let group_to_values = list.reduce(function (obj, item) {
      obj[item.properties.state] = obj[item.properties.state] || [];
      obj[item.properties.state].push(item.properties);
      return obj;
    }, {});

    this.allBranchList = this.groupingFunction(group_to_values);
  }

  loadMap(from: any, data: any) {
    /* Create the map. */
    const map = new google.maps.Map(document.getElementById('divmap'), this.mapOption);

    /* Load the stores GeoJSON onto the map. */
    map.data.loadGeoJson('assets/branches.json', {idPropertyName: 'storeid'});
  
    /* Define the custom marker icons, using the store's "category". */
    map.data.setStyle((feature) => {
      return {
        icon: {
          url: `assets/images/${feature.getProperty('category')}_pin.png`,
          scaledSize: new google.maps.Size(64, 64),
        },
      };
    });

    if(data) {
      this.loadUpdatedMap(null, map, null, data);
    } else {
      if (
        from == 'first_entry' ||
        from == 'findOnMap'
      ) {
        this.loadMapWithoutData(map);
      }
    }
  }

  loadMapWithoutData(map_data) {
    // Geolocation is necessary to center the map based on the user's current position
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.storePositionInLocalStorage(position);
          this.loadUpdatedMap(null, map_data, position, null);
        },
        (err) => {
          this.showError(err);
        },
        {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0
        }
      );
    } else {
      if (localStorage.getItem('language') == 'en') {
        this.toastr.error("Error: Your browser doesn't support geolocation.");
      } else {
        this.toastr.error("Ralat: Penyemak imbas anda tidak menyokong geolokasi.");
      }
    }
  }

  loadUpdatedMap(from, map, position, data) {
    const apiKey = environment.GOOGLE_MAPS_API_KEY;
    const infoWindow = new google.maps.InfoWindow();
    const geocoder = new google.maps.Geocoder();

    if (from) {
      map.data.loadGeoJson('assets/branches.json', {idPropertyName: 'storeid'});
      map.data.setStyle((feature) => {
        return {
          icon: {
            url: `assets/images/${feature.getProperty('category')}_pin.png`,
            scaledSize: new google.maps.Size(64, 64),
          },
        };
      });
      this.loadMapWithUpdatedDetails(from, map, data);
    } else {
      const pos = {
        lat: 0,
        lng: 0
      }
      
      if (position?.coords) {
        pos.lat = position?.coords?.latitude;
        pos.lng = position?.coords?.longitude;
      } else if (position?.geometry?.coordinates) {
        pos.lat = position?.geometry?.coordinates[1];
        pos.lng = position?.geometry?.coordinates[0];
      } else {
        pos.lat = data?.geometry?.coordinates[1];
        pos.lng = data?.geometry?.coordinates[0];
      }

      if(position?.coords) {
        /* Geocode Function */
        geocoder.geocode({ location: pos }, function(results, status) {
          if(status == 'OK') {
            infoWindow.setPosition(pos);
            infoWindow.setOptions({pixelOffset: new google.maps.Size(0, -30)});
            map.setZoom(13);
            map.setCenter(pos);

            let add_component: any = results[0].formatted_address;
            let allresult: any = results;
            localStorage.setItem('currentDetails', JSON.stringify(allresult[allresult.length - 2]));
            localStorage.setItem('currentAddress', add_component);
            let arrayOfadd_component = add_component.split(", ");
            localStorage.setItem('currentState', arrayOfadd_component[arrayOfadd_component.length - 2] + ', ' + arrayOfadd_component[arrayOfadd_component.length - 1]);
          } else {
            this.toastr.error("Geocode was not successful for the following reason: " + status);
          }
        });
        this.loadMapWithUpdatedDetails(from, map, null);
      } else {
        const marker = new google.maps.Marker({
          position: pos,
          map: map,
          clickable: true
        });

        infoWindow.close();
        infoWindow.setPosition(pos);
        infoWindow.setOptions({pixelOffset: new google.maps.Size(0, -30)});
        map.setZoom(13);
        map.setCenter(pos);

        /* Show the information for a store when its marker is clicked. */
        map.data.addListener('click', (event) => {
          const category = event.feature.getProperty('category');
          const name = event.feature.getProperty('name');
          const description = event.feature.getProperty('description');
          const phone = event.feature.getProperty('phone');
          const fax = event.feature.getProperty('fax');
          const ptc = event.feature.getProperty('ptc');
          const email = event.feature.getProperty('email');
          const position = event.feature.getGeometry().get();
          let content = '';
          if(this.selectedLanguage == 'bm') {
            content = `
              <img style="float:left; width:200px; margin-top:30px" src="assets/images/logo_${category}.png">
              <div style="margin-left:220px; margin-bottom:20px;">
                  <h2>${name}</h2><p>${description}</p>
                  <p><b>Tel:</b> ${phone}<br/><b>Fax:</b> ${fax}<br/><b>Pegawai untuk Dihubungi:</b> ${ptc}<br/><b>Emel:</b> ${email}</p>
                  <p><img src="https://maps.googleapis.com/maps/api/streetview?size=350x120&location=${position.lat()},${position.lng()}&key=${apiKey}&solution_channel=GMP_codelabs_simplestorelocator_v1_a"></p>
              </div>
            `;
          } else {
            content = `
              <img style="float:left; width:200px; margin-top:30px" src="assets/images/logo_${category}.png">
              <div style="margin-left:220px; margin-bottom:20px;">
                  <h2>${name}</h2><p>${description}</p>
                  <p><b>Phone:</b> ${phone}<br/><b>Fax:</b> ${fax}<br/><b>Person to contact:</b> ${ptc}<br/><b>Email:</b> ${email}</p>
                  <p><img src="https://maps.googleapis.com/maps/api/streetview?size=350x120&location=${position.lat()},${position.lng()}&key=${apiKey}&solution_channel=GMP_codelabs_simplestorelocator_v1_a"></p>
              </div>
            `;
          }
      
          infoWindow.setContent(content);
          infoWindow.setPosition(pos);
          infoWindow.setOptions({pixelOffset: new google.maps.Size(0, -30)});
          infoWindow.open(map, marker);
          map.setZoom(13);
          map.setCenter(pos);
        });
      }
    }
  }

  loadMapWithUpdatedDetails(from, map, data) {
    const apiKey = environment.GOOGLE_MAPS_API_KEY;
    const infoWindow = new google.maps.InfoWindow();
    let place;
    setTimeout(async () => {
      if (from == null) {
        (<HTMLInputElement>document.getElementById('search')).value = localStorage.getItem('currentState');
      }

      const originMarker = new google.maps.Marker({map: map});
      originMarker.setVisible(false);
      let originLocation = map.getCenter();

      if (from == null) {
        place = JSON.parse(localStorage.getItem('currentDetails'));
      }

      // Recenter the map to the selected address
      if(place?.geometry) {
        originLocation = place?.geometry?.location;
      } else if (data?.geometry?.location) {
        originLocation = data?.geometry?.location;
      } else {
        originLocation = {
          lat: data?.geometry?.coordinates[1],
          lng: data?.geometry?.coordinates[0]
        }
      }

      localStorage.setItem('originLocation', JSON.stringify(originLocation))
      map.setCenter(originLocation);
      map.setZoom(8.5);

      originMarker.setPosition(originLocation);
      originMarker.setVisible(true);;

      /* Show the information for a store when its marker is clicked. */
      map.data.addListener('click', (event) => {
        const category = event.feature.getProperty('category');
        const name = event.feature.getProperty('name');
        const description = event.feature.getProperty('description');
        const phone = event.feature.getProperty('phone');
        const fax = event.feature.getProperty('fax');
        const ptc = event.feature.getProperty('ptc');
        const email = event.feature.getProperty('email');
        const position = event.feature.getGeometry().get();
        let content = '';
        if(this.selectedLanguage == 'bm') {
          content = `
            <img style="float:left; width:200px; margin-top:30px" src="assets/images/logo_${category}.png">
            <div style="margin-left:220px; margin-bottom:20px;">
                <h2>${name}</h2><p>${description}</p>
                <p><b>Tel:</b> ${phone}<br/><b>Fax:</b> ${fax}<br/><b>Pegawai untuk Dihubungi:</b> ${ptc}<br/><b>Emel:</b> ${email}</p>
                <p><img src="https://maps.googleapis.com/maps/api/streetview?size=350x120&location=${position.lat()},${position.lng()}&key=${apiKey}&solution_channel=GMP_codelabs_simplestorelocator_v1_a"></p>
            </div>
          `;
        } else {
          content = `
            <img style="float:left; width:200px; margin-top:30px" src="assets/images/logo_${category}.png">
            <div style="margin-left:220px; margin-bottom:20px;">
                <h2>${name}</h2><p>${description}</p>
                <p><b>Phone:</b> ${phone}<br/><b>Fax:</b> ${fax}<br/><b>Person to contact:</b> ${ptc}<br/><b>Email:</b> ${email}</p>
                <p><img src="https://maps.googleapis.com/maps/api/streetview?size=350x120&location=${position.lat()},${position.lng()}&key=${apiKey}&solution_channel=GMP_codelabs_simplestorelocator_v1_a"></p>
            </div>
          `;
        }
      
        infoWindow.close();
        infoWindow.setContent(content);
        infoWindow.setPosition({lat: position.lat(), lng: position.lng()});
        infoWindow.setOptions({pixelOffset: new google.maps.Size(0, -30)});
        infoWindow.open(map);
        map.setZoom(13);
        map.setCenter({lat: position.lat(), lng: position.lng()});
      });

      // Use the selected address as the origin to calculate distances
      // to each of the store locations
      const rankedStores = await this.calculateDistances(from, map.data, originLocation);
      this.showStoresList(map.data, rankedStores);
    }, 1500);
  }

  async calculateDistances(from, data, origin) {
    const stores = [];
    const destinations = [];

    // Build parallel arrays for the store IDs and destinations
    data.forEach((store) => {
      const storeNum = store.getProperty('storeid');
      const storeLoc = store.getGeometry().get();

      stores.push(storeNum);
      destinations.push(storeLoc);
    });

    // Retrieve the distances of each store from the origin
    // The returned list will be in the same order as the destinations list
    const service = new google.maps.DistanceMatrixService();
    const getDistanceMatrix =
      (service, parameters) => {
        return new Promise((resolve, reject) => {
        service.getDistanceMatrix(parameters, (response, status) => {
          if (status !== google.maps.DistanceMatrixStatus.OK) {
            reject(response);
          } else {
            const distances = [];
            const results = response.rows[0].elements;
            for (let j = 0; j < results.length; j++) {
              const element = results[j];
              const distanceText = element.distance.text;
              const distanceVal = element.distance.value;
              const distanceObject = {
                storeid: stores[j],
                distanceText: distanceText,
                distanceVal: distanceVal,
              };
              distances.push(distanceObject);
            }
            resolve(distances);
          }
        });
      });
    };

    let originToBePased;
    if (from == null) {
      originToBePased = {
        lat: Number(localStorage.getItem('lat')),
        lng: Number(localStorage.getItem('lng'))
      };
    } else {
      originToBePased = origin;
    }

    const distancesList:any = await getDistanceMatrix(service, {
      origins: [originToBePased],
      destinations: destinations,
      travelMode: 'DRIVING',
      unitSystem: google.maps.UnitSystem.METRIC,
    });
    
    distancesList.sort((first, second) => {
      return first.distanceVal - second.distanceVal;
    });

    return distancesList;
  }

  showStoresList(data, stores) {
    if (stores.length == 0) {
      this.toastr.warning('empty stores');
      return;
    }

    let newArray = [];
    for (let i = 0; i < stores.length; i++) {
      for (let j = 0; j<branch.features.length; j++) {
        if (stores[i].storeid == branch.features[j].properties.storeid) {
         const combined = {...stores[i], ...branch.features[j].properties};
         newArray.push(combined);
        }
      }
    }

    let sliced = newArray.slice(0,3);
    let group_to_values = sliced.reduce(function (obj, item) {
      obj[item.state] = obj[item.state] || [];
      obj[item.state].push(item);
      return obj;
    }, {});

    this.branchLists = this.groupingFunction(group_to_values);
  }

  storePositionInLocalStorage(position?: any) {
    localStorage.setItem('lat', position.coords.latitude);
    localStorage.setItem('lng', position.coords.longitude);
  }

  showError(error) {
    if(error.code) {
      if(error.code == 1) {
        if(localStorage.getItem('language') == 'en') {
          this.toastr.error("User denied the request for Geolocation.");
        } else {
          this.toastr.error("Pengguna menolak permintaan untuk Geolokasi.");
        }
      } else {
        this.toastr.error(error.code);
        // case error.POSITION_UNAVAILABLE:
        //     alert("Location information is unavailable.")
        //     break;
        // case error.TIMEOUT:
        //     alert("The request to get user location timed out.")
        //     break;
        // case error.UNKNOWN_ERROR:
        //     alert("An unknown error occurred.")
        //     break;
      }
    }
  }

  async loadMapAfterSearch(data: any) {
    const map = new google.maps.Map(document.getElementById('divmap'), this.mapOption);
    this.mobileMapData = {
      type: 'aftersearch',
      map: map,
      position: null,
      data: data
    }
    this.loadUpdatedMap('aftersearch', map, null, data)
  }

  findLocationBySearch(data: any) {
    if (data.keyCode !== 13) {
      if ((data.target.value == '' || data.target.value == null)) {
        localStorage.removeItem('currentAddress');
        this.branchLists = this.allBranchList;
      } else {
        const searchBar: any = document.getElementById('search');
        const options = { componentRestrictions: {country: 'my'} };
        const autocomplete = new google.maps.places.Autocomplete(searchBar, options);
        autocomplete.addListener('place_changed', async () => {
          const place = autocomplete.getPlace();
          if ( place?.address_components ) {
            localStorage.setItem('currentAddress', place?.formatted_address);
            this.loadMapAfterSearch(place);
          }
        })
      }
    }
  }

  findOnMap(data?: any) {
    if(data) {
      this.mobileMapData = {
        type: 'findOnMap',
        data: data,
      }
      this.loadMap('findOnMap', data);
    } else {
      this.mobileMapData = {};
      this.loadMap('findOnMap', null);
    }
  }

  findDirection(data: any) {
    const url = "https://www.google.com/maps/dir/?api=1&origin=";
    const latLng = localStorage.getItem('lat') + ',' + localStorage.getItem('lng');
    const origin = localStorage.getItem('currentAddress');
    const destination = data.description;
    const additionalUrl = "&destination=";
    const modeUrl = "&travelmode=driving";
    window.open(url+origin+additionalUrl+destination+modeUrl);
  }

  preventEnter(event) {
    if(event.keyCode == 13) {
      event.preventDefault();
      if(this.selectedLanguage == 'bm') {
        this.toastr.warning('Sila pilih daripada senarai');
      } else {
        this.toastr.warning('Please pick and click from the list');
      }
      return false;
    }
  }

  openDialog() {
    const dialogRef = this.dialog.open(CgcNearestLocationMobileComponent, {
      data: this.mobileMapData,
      width: "100%"
    });
  }

  changeMenuCondition(event: any) {
    this.clickedOutside = false;
  }

  closeMegaMenuCondition() {
    this.clickedOutside = !this.clickedOutside;
  }

  switchLanguageHandler(data: any) {
    this.languageSelected = data;
  }
}
